import { useDimensions } from 'hooks/useDimensions/useDimensions';
import { IntroDesktop } from 'pages/Intro/Intro.desktop';
import { IntroMobile } from 'pages/Intro/Intro.mobile';

export const Intro = () => {
  const { isMobileOrTablet } = useDimensions();

  return isMobileOrTablet ? <IntroMobile /> : <IntroDesktop />;
};
